export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"Content-Type","content":"text/html"},{"http-equiv":"Content-Style-Type","content":"text/css"},{"http-equiv":"Content-Script-Type","content":"text/javascript"},{"name":"robots","content":"index,follow"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"facebook-domain-verification","content":"3di5lwsx4yb1dwy6eqvh84h2p61qvt"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"/favicon/mstile-144x144.png"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":""},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Jost:wght@100..900&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Shippori+Mincho&display=swap"}],"style":[{"innerHTML":".async-hide { opacity: 0 !important }"}],"script":[{"src":"https://www.google.com/recaptcha/enterprise.js?render=6Lc4SL0rAAAAAHm7XrIOq9u2bx4XOabwaVZtSlg0&badge=bottomleft","defer":true,"async":true},{"type":"text/javascript","innerHTML":"\n          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-PH4SDD');"},{"type":"text/javascript","innerHTML":"\n          (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;\n          h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};\n          (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;\n          })(window,document.documentElement,'async-hide','dataLayer',4000,\n          {'GTM-WFJPBQP':true})"},{"type":"text/javascript","innerHTML":"\n          (function() {\n            'use strict';\n            const node = document.getElementsByTagName('html');\n            for (const elm of node) {\n                const attr = elm.getAttribute('style') || '';\n                elm.setAttribute('style', attr + ';opacity:1 !important;');\n                elm.classList.remove('async-hide');\n            }\n          })()"}],"noscript":[{"innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-PH4SDD\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}],"htmlAttrs":{"lang":"ja"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true